import { createContext, useContext, useEffect, useRef } from 'react';

export const FocusGuardContext = createContext(null);

// Marks a running simulation / quiz: full screen is required while active, and onForceEnd runs before a strike-out sign-out
export const useProctoredAttempt = ({ active, label, onForceEnd }) => {
    const ctx = useContext(FocusGuardContext);
    const endRef = useRef(onForceEnd);
    endRef.current = onForceEnd;
    const register = ctx?.registerAttempt;
    useEffect(() => {
        if (!active || !register) return undefined;
        return register({ label, onForceEnd: () => endRef.current?.() });
    }, [active, label, register]);
};
